import { AddressService } from '../services/address.service'
import { addressesConstants, toastConstants } from '../constants'

const getAddresses = userId => async dispatch => {
	AddressService.getAddresses(userId).then(({ data: addresses }) => {
		dispatch({ type: addressesConstants.GET, payload: addresses })
	})
}

const addOrUpdateAddress = (userId, address) => async dispatch => {
	AddressService.addOrUpdate(userId, address).then(({ success, errors }) => {
		if (success) {
			getAddresses(userId)(dispatch)
			dispatch({
				type: addressesConstants.SET_EDITING_ADDRESS_ID,
				payload: null
			})
		} else {
			dispatch({
				type: toastConstants.DANGER,
				message: errors[0]
			})
		}
	})
}

const inactivateAddress = (userId, addressId) => async dispatch => {
	AddressService.inactivateAddress(userId, addressId).then(
		({ success, errors }) => {
			success
				? getAddresses(userId)(dispatch)
				: console.log('Erro ao inativar o endereço', errors)
		}
	)
}

const setEditingAddressId = id => dispatch => {
	dispatch({ type: addressesConstants.SET_EDITING_ADDRESS_ID, payload: id })
}

const openChangeAddressModal = () => dispatch => {
	dispatch({ type: addressesConstants.OPEN_EDIT_ADDRESS_MODAL })
}

const closeChangeAddressModal = () => dispatch => {
	dispatch({ type: addressesConstants.CLOSE_EDIT_ADDRESS_MODAL })
}

const openNewAddressModal = () => dispatch => {
	dispatch({ type: addressesConstants.OPEN_NEW_ADDRESS_MODAL })
}

const closeNewAddressModal = () => dispatch => {
	dispatch({ type: addressesConstants.CLOSE_NEW_ADDRESS_MODAL })
}

const setAddressesOwnerId = clientId => dispatch => {
	dispatch({
		type: addressesConstants.SET_ADDRESSES_OWNER_ID,
		payload: clientId
	})
}

export const addressesActions = {
	getAddresses,
	addOrUpdateAddress,
	inactivateAddress,
	setEditingAddressId,
	openChangeAddressModal,
	closeChangeAddressModal,
	openNewAddressModal,
	closeNewAddressModal,
	setAddressesOwnerId
}
